import { render } from "./NotFound.vue?vue&type=template&id=31d25bf0&scoped=true&ts=true"
import script from "./NotFound.vue?vue&type=script&lang=ts"
export * from "./NotFound.vue?vue&type=script&lang=ts"

import "./NotFound.vue?vue&type=style&index=0&id=31d25bf0&scoped=true&lang=scss"

import exportComponent from "/builds/Moodbuster2.0/server/web-server/repos/patient_portal_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d25bf0"]])

export default __exports__